import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { AppRoutes } from '@/constants/appRoutes'
import {
  EReportType,
  ERunReportQueryParam,
  ESearchType,
} from '@/pages/RunReport/types'
import {
  clearNewSearch,
  setSearchType,
} from '@/store/api/RunReport/RunReport.slice'

import { ProductCard } from '../ProductCard/ProductCard'

interface SearchSectionProps {
  aiReportCredits: number
  aiAnalystReportCredits: number
  adverseMediaReportCredits: number
  assistedReportCredits: number
  facialMatchingCredits: number
}

export const SearchSection = ({
  aiReportCredits,
  aiAnalystReportCredits,
  adverseMediaReportCredits,
  facialMatchingCredits,
}: SearchSectionProps) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const startReport = (reportType: EReportType) => {
    dispatch(clearNewSearch())

    if (reportType === EReportType.AiReport) {
      dispatch(setSearchType(ESearchType.Individual))
      navigate(
        `${AppRoutes.runReportSearchForm}?${ERunReportQueryParam.ReportType}=${reportType}`,
      )
      return
    }

    navigate(
      `${AppRoutes.runReportStartSearch}?${ERunReportQueryParam.ReportType}=${reportType}`,
    )
  }

  const goToFaceSearch = () => navigate(AppRoutes.faceSearch)

  return (
    <div className="flex w-full max-w-[1200px] flex-col gap-6">
      <div className="flex flex-col gap-6 lg:flex-row">
        <ProductCard
          title={t('dashboard.home.productCards.analystVerified.title')}
          description={t(
            'dashboard.home.productCards.analystVerified.description',
          )}
          credits={aiAnalystReportCredits}
          turnaround={t(
            'dashboard.home.productCards.analystVerified.turnaround',
          )}
          buttonLabel={t(
            'dashboard.home.productCards.analystVerified.buttonLabel',
          )}
          onClick={() => startReport(EReportType.AiAnalystReport)}
        />
        <ProductCard
          title={t('dashboard.home.productCards.aiGenerated.title')}
          description={t('dashboard.home.productCards.aiGenerated.description')}
          credits={aiReportCredits}
          turnaround={t('dashboard.home.productCards.aiGenerated.turnaround')}
          buttonLabel={t('dashboard.home.productCards.aiGenerated.buttonLabel')}
          onClick={() => startReport(EReportType.AiReport)}
        />
      </div>
      <div className="flex flex-col gap-6 lg:flex-row">
        <ProductCard
          title={t('dashboard.home.productCards.adverseMedia.title')}
          description={t(
            'dashboard.home.productCards.adverseMedia.description',
          )}
          credits={adverseMediaReportCredits}
          turnaround={t('dashboard.home.productCards.adverseMedia.turnaround')}
          buttonLabel={t(
            'dashboard.home.productCards.adverseMedia.buttonLabel',
          )}
          onClick={() => startReport(EReportType.AdverseMediaReport)}
        />
        <ProductCard
          title={t('dashboard.home.productCards.facialRecognition.title')}
          description={t(
            'dashboard.home.productCards.facialRecognition.description',
          )}
          credits={facialMatchingCredits}
          turnaround={t(
            'dashboard.home.productCards.facialRecognition.turnaround',
          )}
          buttonLabel={t(
            'dashboard.home.productCards.facialRecognition.buttonLabel',
          )}
          onClick={goToFaceSearch}
        />
      </div>
    </div>
  )
}
